"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CalendarContext = require("./CalendarContext");
const CalendarLocaleProvider = _ref => {
  let {
    locale,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_CalendarContext.CalendarContextProvider, {
    value: {
      locale
    }
  }, children);
};
process.env.NODE_ENV !== "production" ? CalendarLocaleProvider.propTypes = {
  locale: _propTypes.default.shape({
    fullDateFormat: _propTypes.default.string.isRequired,
    dateFormat: _propTypes.default.string.isRequired,
    monthLabel: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
    weekStartOnMondays: _propTypes.default.bool.isRequired,
    dayLabel: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
    dayLabelShort: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired
  }).isRequired,
  children: _propTypes.default.node
} : void 0;
CalendarLocaleProvider.defaultProps = {
  children: undefined
};
var _default = exports.default = CalendarLocaleProvider;